// Chat Challenge conversation flows for all 8 conversation types

export const getChatChallengeFlow = (conversationNum, topicText) => {
    const flows = {
        // 0: Favorite Things - Animal
        0: [
            {
                text: "Say, \"We are going to talk about our favorite animal.\"",
                type: "instruction",
                sender: "friend"
            },
            {
                text: "Greet your friend.",
                type: "instruction",
                sender: "friend"
            },
            {
                text: "Did your friend greet you?",
                type: "question",
                sender: "friend",
                reminder: "Say, \"Remember to greet me.\"",
                returnToStep: 1
            },
            {
                text: "Ask, \"What is your favorite animal?\"",
                type: "instruction",
                sender: "friend"
            },
            {
                text: "Did your friend answer your question?",
                type: "question",
                sender: "friend",
                reminder: "Say, \"Remember to answer my question.\"",
                returnToStep: 3
            },
            {
                text: "Respond to your friend's answer.",
                type: "instruction",
                sender: "friend"
            },
            {
                text: "Did your friend ask you a question about your favorite animal?",
                type: "question",
                sender: "friend",
                reminder: "Say, \"Remember to ask me a question.\"",
                returnToStep: 5
            },
            {
                text: "Answer your friend's question.",
                type: "instruction",
                sender: "friend"
            },
            {
                text: "Did your friend respond to your answer?",
                type: "question",
                sender: "friend",
                reminder: "Say, \"Remember to respond to my answer.\"",
                returnToStep: 7
            },
            {
                text: "Close the conversation with your friend.",
                type: "instruction",
                sender: "friend"
            },
            {
                text: "Did your friend close the conversation?",
                type: "question",
                sender: "friend",
                reminder: "Say, \"Remember to close the conversation.\"",
                returnToStep: 9
            },
            {
                text: "Say, \"Good job!\"",
                type: "instruction",
                sender: "friend"
            }
        ],

        // 1: Talk about Feelings
        1: [
            {
                text: "Say, \"We are going to talk about what makes you feel confident.\"",
                type: "instruction",
                sender: "friend"
            },
            {
                text: "Ask, \"What makes you feel confident?\"",
                type: "instruction",
                sender: "friend"
            },
            {
                text: "Did your friend answer your question? (I feel confident when_____.)",
                type: "question",
                sender: "friend",
                reminder: "Say, \"Remember to answer my question.\"",
                returnToStep: 1
            },
            {
                text: "Say, \"I'm glad that makes you feel confident when ______.\"",
                type: "instruction",
                sender: "friend"
            },
            {
                text: "Did your friend thank you?",
                type: "question",
                sender: "friend",
                reminder: "Say, \"Remember to thank me.\"",
                returnToStep: 3
            },
            {
                text: "Say, \"Good job!\"",
                type: "instruction",
                sender: "friend"
            }
        ],

        // 2: Active Listening
        2: [
            {
                text: "Say, \"We are going to talk about what makes me feel calm.\"",
                type: "instruction",
                sender: "friend"
            },
            {
                text: "Say to your friend, \"Ask me what makes me feel calm.\"",
                type: "instruction",
                sender: "friend"
            },
            {
                text: "Did your friend ask, \"What makes you feel calm?\"",
                type: "question",
                sender: "friend",
                reminder: "Say, \"Remember to ask me a question.\"",
                returnToStep: 1
            },
            {
                text: "Answer your friend's question. (I feel calm when ______.)",
                type: "instruction",
                sender: "friend"
            },
            {
                text: "Did your friend respond to your answer? (I'm glad you feel calm when ______.)",
                type: "question",
                sender: "friend",
                reminder: "Say, \"Remember to respond to my answer.\"",
                returnToStep: 3
            },
            {
                text: "Thank your friend.",
                type: "instruction",
                sender: "friend"
            },
            {
                text: "Say, \"Good job!\"",
                type: "instruction",
                sender: "friend"
            }
        ],

        // 3: Making Friends
        3: [
            {
                text: "Say, \"We are going to talk about our favorite thing to do outside.\"",
                type: "instruction",
                sender: "friend"
            },
            {
                text: "Say, \"Greet me and ask me my name.\"",
                type: "instruction",
                sender: "friend"
            },
            {
                text: "Did your friend greet you and ask your name?",
                type: "question",
                sender: "friend",
                reminder: "Say, \"Remember to greet me and ask me a question.\"",
                returnToStep: 1
            },
            {
                text: "Greet your friend and say your name.",
                type: "instruction",
                sender: "friend"
            },
            {
                text: "Did your friend ask you, \"What is your favorite thing to do outside?\"",
                type: "question",
                sender: "friend",
                reminder: "Say, \"Remember to ask me a question about my favorite thing to do outside.\"",
                returnToStep: 3
            },
            {
                text: "Answer your friend's question.",
                type: "instruction",
                sender: "friend"
            },
            {
                text: "Did your friend respond to your answer?",
                type: "question",
                sender: "friend",
                reminder: "Say, \"Remember to respond to my answer.\"",
                returnToStep: 5
            },
            {
                text: "Ask, \"What is your favorite thing to do outside?\"",
                type: "instruction",
                sender: "friend"
            },
            {
                text: "Did your friend answer your question?",
                type: "question",
                sender: "friend",
                reminder: "Say, \"Remember to answer my question.\"",
                returnToStep: 7
            },
            {
                text: "Respond to your friend's answer.",
                type: "instruction",
                sender: "friend"
            },
            {
                text: "Did your friend close the conversation?",
                type: "question",
                sender: "friend",
                reminder: "Say, \"Remember to close the conversation.\"",
                returnToStep: 9
            },
            {
                text: "Close the conversation with your friend.",
                type: "instruction",
                sender: "friend"
            },
            {
                text: "Say, \"Good job!\"",
                type: "instruction",
                sender: "friend"
            }
        ],

        // 4: Solutions
        4: [
            {
                text: "Say, \"We are going to talk about what makes you feel nervous.\"",
                type: "instruction",
                sender: "friend"
            },
            {
                text: "Ask, \"What makes you feel nervous?\"",
                type: "instruction",
                sender: "friend"
            },
            {
                text: "Did your friend answer your question? (I feel nervous when ______.)",
                type: "question",
                sender: "friend",
                reminder: "Say, \"Remember to answer my question.\"",
                returnToStep: 1
            },
            {
                text: "Respond to your friend's answer (I'm sorry you feel nervous when ______.) and ask, \"What is a solution?\"",
                type: "instruction",
                sender: "friend"
            },
            {
                text: "Did your friend answer your question?",
                type: "question",
                sender: "friend",
                reminder: "Say, \"Remember to answer my question.\"",
                returnToStep: 3
            },
            {
                text: "Respond to your friend's answer.",
                type: "instruction",
                sender: "friend"
            },
            {
                text: "Say, \"Good job!\"",
                type: "instruction",
                sender: "friend"
            }
        ],

        // 5: Resolve Conflict
        5: [
            {
                text: "If I sat where you wanted to sit on the bus, how would you resolve the conflict? Tell me the first step.",
                type: "instruction",
                sender: "friend"
            },
            {
                text: "Did your friend say, \"Be Calm\"?",
                type: "question",
                sender: "friend",
                reminder: "Say, \"The first step is, 'Be Calm.'\"",
                returnToStep: 0
            },
            {
                text: "What is the second step to resolve conflict?",
                type: "instruction",
                sender: "friend"
            },
            {
                text: "Did your friend say, \"Talk About It\"?",
                type: "question",
                sender: "friend",
                reminder: "Say, \"The second step is, 'Talk About It.'\"",
                returnToStep: 2
            },
            {
                text: "If I was sitting where you wanted to sit, how would you talk about it with me?",
                type: "instruction",
                sender: "friend"
            },
            {
                text: "Did your friend say, \"I feel sad because _____.\"?",
                type: "question",
                sender: "friend",
                reminder: "Say, \"Remember to tell me why you feel sad.\"",
                returnToStep: 4
            },
            {
                text: "What is the third step to resolve conflict?",
                type: "instruction",
                sender: "friend"
            },
            {
                text: "Did your friend say, \"Make It Better\"?",
                type: "question",
                sender: "friend",
                reminder: "Say, \"The third step is, 'Make It Better.'\"",
                returnToStep: 6
            },
            {
                text: "How can you make this situation better?",
                type: "instruction",
                sender: "friend"
            },
            {
                text: "Did your friend tell you how they can make it better?",
                type: "question",
                sender: "friend",
                reminder: "Say, \"Remember to tell me how to make the situation better.\"",
                returnToStep: 8
            },
            {
                text: "Say, \"Good job!\"",
                type: "instruction",
                sender: "friend"
            }
        ],

        // 6: Self-Advocacy
        6: [
            {
                text: "If you are at the snack shack and need a napkin, what is the first step to self-advocate?",
                type: "instruction",
                sender: "friend"
            },
            {
                text: "Did your friend say, \"Think About What You Want to Say\"?",
                type: "question",
                sender: "friend",
                reminder: "Say, \"The first step is, 'Think About What You Want to Say.'\"",
                returnToStep: 0
            },
            {
                text: "What is the second step to self-advocate?",
                type: "instruction",
                sender: "friend"
            },
            {
                text: "Did your friend say, \"Believe in Yourself\"?",
                type: "question",
                sender: "friend",
                reminder: "Say, \"The second step is, 'Believe in Yourself.'\"",
                returnToStep: 2
            },
            {
                text: "Can you sing or say the Joyful Jingle?",
                type: "instruction",
                sender: "friend"
            },
            {
                text: "Did your friend sing or say the Joyful Jingle?",
                type: "question",
                sender: "friend",
                reminder: "Say, \"Let's sing or say the Joyful Jingle together!\"",
                returnToStep: 4
            },
            {
                text: "What is the third step to self-advocate?",
                type: "instruction",
                sender: "friend"
            },
            {
                text: "Did your friend say, \"Achieve It\"?",
                type: "question",
                sender: "friend",
                reminder: "Say, \"The third step is, 'Achieve It.'\"",
                returnToStep: 6
            },
            {
                text: "Now, let's practice the conversation.",
                type: "instruction",
                sender: "friend"
            },
            {
                text: "Say, \"Hi! I work at the snack shack. How can I help you?\"",
                type: "instruction",
                sender: "friend"
            },
            {
                text: "Did your friend greet you and ask where the napkins are?",
                type: "question",
                sender: "friend",
                reminder: "Say, \"Remember to greet me and ask where the napkins are.\"",
                returnToStep: 9
            },
            {
                text: "Say, \"Sure! The napkins are right by the drinks.\"",
                type: "instruction",
                sender: "friend"
            },
            {
                text: "Did your friend respond to your answer with good manners and close the conversation?",
                type: "question",
                sender: "friend",
                reminder: "Say, \"Remember to respond to my answer with good manners and close the conversation.\"",
                returnToStep: 11
            },
            {
                text: "Close the conversation.",
                type: "instruction",
                sender: "friend"
            },
            {
                text: "Say, \"Good job!\"",
                type: "instruction",
                sender: "friend"
            }
        ],

        // 7: Community Locations
        7: [
            {
                text: "If you are at the clothing store to buy new socks for yourself and you don't know where they are, what is the first step to care for yourself?",
                type: "instruction",
                sender: "friend"
            },
            {
                text: "Did your friend say, \"See It\"?",
                type: "question",
                sender: "friend",
                reminder: "Say, \"The first step is, 'See It.'\"",
                returnToStep: 0
            },
            {
                text: "What problem do you see?",
                type: "instruction",
                sender: "friend"
            },
            {
                text: "Did your friend say, \"I don't know where the socks are in the store.\"?",
                type: "question",
                sender: "friend",
                reminder: "Say, \"Remember that you don't know where the socks are in the store.\"",
                returnToStep: 2
            },
            {
                text: "What is the second step to care for yourself?",
                type: "instruction",
                sender: "friend"
            },
            {
                text: "Did your friend say, \"Fix It\"?",
                type: "question",
                sender: "friend",
                reminder: "Say, \"The second step is, 'Fix It.'\"",
                returnToStep: 4
            },
            {
                text: "How would you fix this problem?",
                type: "instruction",
                sender: "friend"
            },
            {
                text: "Did your friend say, \"I will ask a worker for help.\"?",
                type: "question",
                sender: "friend",
                reminder: "Say, \"Remember to ask a worker for help.\"",
                returnToStep: 6
            },
            {
                text: "What is the third step to care for yourself?",
                type: "instruction",
                sender: "friend"
            },
            {
                text: "Did your friend say, \"Make It Better\"?",
                type: "question",
                sender: "friend",
                reminder: "Say, \"The third step is, 'Make It Better.'\"",
                returnToStep: 8
            },
            {
                text: "What can you say or do for the worker who helped you find the socks?",
                type: "instruction",
                sender: "friend"
            },
            {
                text: "Did your friend say something nice?",
                type: "question",
                sender: "friend",
                reminder: "Say, \"Remember to say or do something nice for the worker.\"",
                returnToStep: 10
            },
            {
                text: "Now, let's practice having a conversation using good manners.",
                type: "instruction",
                sender: "friend"
            },
            {
                text: "Say, \"Hi! I work at a clothing store. How can I help you?\"",
                type: "instruction",
                sender: "friend"
            },
            {
                text: "Did your friend greet the worker and ask where the socks are while using good manners? (Please)",
                type: "question",
                sender: "friend",
                reminder: "Say, \"Remember to greet the worker and use good manners when asking where the socks are.\"",
                returnToStep: 13
            },
            {
                text: "Say, \"The socks are on the first aisle on your left.\"",
                type: "instruction",
                sender: "friend"
            },
            {
                text: "Did your friend respond using good manners? (Thank you)",
                type: "question",
                sender: "friend",
                reminder: "Say, \"Remember to respond using good manners.\"",
                returnToStep: 15
            },
            {
                text: "Use good manners and then close the conversation.",
                type: "instruction",
                sender: "friend"
            },
            {
                text: "Did your friend close the conversation?",
                type: "question",
                sender: "friend",
                reminder: "Say, \"Remember to close the conversation.\"",
                returnToStep: 17
            },
            {
                text: "Step 1: How I act. Did your friend use the 5 foundational skills (eye contact, listening, smile, posture, distance)?",
                type: "question",
                sender: "friend",
                reminder: "Say, \"Remember to use the 5 foundational skills.\"",
                returnToStep: 13
            },
            {
                text: "Step 2: What I say: Did your friend use kind words?",
                type: "question",
                sender: "friend",
                reminder: "Say, \"Remember to use kind words.\"",
                returnToStep: 13
            },
            {
                text: "Step 3: How I say it: Did your friend talk in a calm voice?",
                type: "question",
                sender: "friend",
                reminder: "Say, \"Remember to talk in a calm voice.\"",
                returnToStep: 13
            },
            {
                text: "Say, \"Good job!\"",
                type: "instruction",
                sender: "friend"
            }
        ]
    };

    return flows[conversationNum] || flows[0];
};

